import { createContext } from "react";

export const ServiceRequestContext = createContext({
    listOfServiceRequests: [],
    listOfStages:[],
    listOfRequestTypes:[],
    listOfCompanies:[],
    selectedRequest:null,
    setListOfServiceRequests:() => {},
    setSelectedRequest:() => {}
});